import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";
import stringUtils from "@shared/utils/string-utils.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.VIRTUAL_PURCHASED_DT,
  displayName: "Data Transfer",
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "data-transfer-icon",
    title: "Data Transfer",
    valueTransformer: (value) => {
      if (value === "N/A" || value === "Annual Contract") {
        return value;
      }
      return stringUtils.formatUsageWithUnit(value) + "/month";
    },
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: stringUtils.formatUsageWithUnit(value),
        units: "Per month",
      };
    },
  },
};

export default entitlement;
